import { useContext, useRef } from "react";
import { useHistory } from "react-router-dom";
import { API, Auth } from "aws-amplify";
import { AccountAdminContext } from "components/AccountAdmin/AccountAdmin-container";
import { ModalContext } from "contexts/Modal";

const useAccountAdminContract = (contractId, accountId) => {
  const history = useHistory();
  const { showModal, showConfirm } = useContext(ModalContext);
  const { updateAccount } = useContext(AccountAdminContext);
  const inFlight = useRef(false);

  const ensureAuthed = async () => {
    await Auth.currentAuthenticatedUser();
  };

  const manageContract = () => {
    history.push(`/ContractAdmin/${contractId}`);
  };

  const terminate = async () => {
    if (inFlight.current) return; // guard against double-submit
    inFlight.current = true;
    try {
      await ensureAuthed();
      await API.del(
        "AccountGatewayApi",
        `/account/${accountId}/contract/${contractId}`);
      updateAccount(true);
      showModal("Terminate Contract", "Contract successfully terminated.");
    } catch (err) {
      console.error("error terminating contract", err);
      showModal("Terminate Contract", "Error terminating contract.");
    } finally {
      inFlight.current = false;
    }
  };

  const handleTerminate = (event) => {
    if (event) event.preventDefault();

    if (!accountId || !contractId) {
      showModal("Terminate Contract", "Missing account or contract id.");
      return;
    }

    try {
      showConfirm(
        "Terminate contract",
        "Do you really want to terminate the contract?",
        terminate
      );
    } catch (err) {
      console.error(
        "AccountAdminContract-logic.js handleTerminate error",
        err
      );
    }
  };

  return {
    manageContract,
    terminateContract: handleTerminate,
  };
};

export default useAccountAdminContract;
